import { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDInput from "components/MDInput";
import MDPopup from "components/MDPopup";
import MDAlert from "components/MDAlert";

import MDSelect from "components/MDSelect";

import { Link } from "react-router-dom";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPost } from "../../../api";

import { DownloadFile } from "../../../utils";

const UserPage = () => {
  const { user } = useAuthContext();

  const navigate = useNavigate();

  const [submitValidation, setSubmitValidation] = useState(false);

  const [ title, setTitle ] = useState("");

  const [ description, setDescription ] = useState("");

  const [ type, setType ] = useState("");

  useEffect(() => {
    setSubmitValidation(!!title && !!description && !!type);
  }, [title, description, type])

  const handleSubmit = () => {
    httpPost(process.env.REACT_APP_URL_BASE + "/ticket/create", {
      title: title,
      description: description,
      type: type
    }).then((response) => {
      if (response.status === 201) {
        // should redirect to ticket page

        response.json().then((json) => {
          navigate("/tickets/" + json.insertId);
        })
        
      }else{
        alert("Something went wrong");

        console.log(response);
      }
    });
  }


  return ( 
    <>
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="error"
                borderRadius="lg"
                coloredShadow="info"
                sx={{textAlign: "center"}}
              >
                <MDTypography variant="h3" color="white">
                  New ticket
                </MDTypography>
              </MDBox>
              <MDBox p={3} sx={{
                  display: "flex",
                  justifyContent:"center",
                  alignItems: "center",
                  flexDirection: 'column'}}>

                  <MDBox m={3} sx={{ width: "100%", height: "100%", display: "flex", justifyContent:"space-around" }}>
                    <MDBox sx={{width: "70%", display: "flex", textAlign: "center", justifyContent: "center", flexDirection: "column"}}>
                      <MDTypography variant="label">
                        Title of the ticket
                      </MDTypography>

                      <MDInput type="text" label="Type here..." onChange={(e) => setTitle(e.target.value)} />

                      <br />

                      <MDTypography variant="label">
                        Description of the ticket
                      </MDTypography>

                      <MDInput type="text" label="Type here..." multiline rows={5} onChange={(e) => setDescription(e.target.value)} />

                      <br />

                      <MDTypography variant="label">
                        Type of the ticket
                      </MDTypography>

                      <MDSelect label="Type" menu={[
                        { label: "Product Bug", value: 1 },
                        { label: "Information Request", value: 2 },
                        ]} onChange={(e) => setType(e.target.value)} />
                    </MDBox>
                  </MDBox>

                  <MDButton variant="gradient" color="success" disabled={!submitValidation} onClick={handleSubmit}>
                    Open new
                  </MDButton>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
    </>

  )
}

export default UserPage